import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ItemSpecActivity extends Component {
    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Hospitality/ItemSpec/ItemSpecBrowser")
    }

    render() {
        return (
            <Activity 
                name="ItemSpec"
                context="ItemSpec"
                RenderedComponent={this.RenderedComponent}
            />
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ItemSpecActivity)
